import React from 'react'
import { GiSpy } from 'react-icons/gi'
import { IoMenuOutline, IoSearch } from 'react-icons/io5'
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react'
import { useSidebar } from '../context/SidebarContext'
import { AlertsCenter } from './AlertsCenter'

// Check if Clerk is configured
const clerkEnabled = !!(import.meta as any).env?.VITE_CLERK_PUBLISHABLE_KEY

export function MobileHeader() {
  const { toggleMobileMenu } = useSidebar()

  return (
    <header className="mobile-header">
      <div className="mobile-header-left">
        <button
          className="mobile-menu-btn"
          onClick={toggleMobileMenu}
          aria-label="Open menu"
        >
          <IoMenuOutline size={24} />
        </button>
        <div className="mobile-header-brand">
          <GiSpy style={{ fontSize: 20, color: 'var(--accent)' }} />
          <span>StatScout</span>
        </div>
      </div>

      <div className="mobile-header-right">
        <button
          className="mobile-search-btn"
          onClick={() => {
            const event = new KeyboardEvent('keydown', {
              key: 'k',
              metaKey: true,
              bubbles: true,
            })
            document.dispatchEvent(event)
          }}
          aria-label="Search"
        >
          <IoSearch size={20} />
        </button>
        {clerkEnabled && (
          <>
            <SignedIn>
              <AlertsCenter />
              <UserButton
                afterSignOutUrl="/"
                appearance={{
                  elements: {
                    avatarBox: 'clerk-avatar',
                  },
                }}
              />
            </SignedIn>
            <SignedOut>
              <a href="/sign-in" className="topbar-sign-in">
                Sign In
              </a>
            </SignedOut>
          </>
        )}
      </div>
    </header>
  )
}
